<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

defineProps<{
  property: PropertyOnPage
}>();
</script>

<template>
  <section class="pt-2xl">
    <IadTitle
      tag="h3"
      :text="$t(`property.price.details`)"
      class="mb-s"
    />
    <PropertySectionPriceSale
      v-if="property.prices.type === `sale`"
      :prices="property.prices"
    />
    <PropertySectionPriceRent
      v-else
      :prices="property.prices"
    />
  </section>
</template>
